import React, { useState, useEffect } from 'react';
import Card from './common/Card';
import axios from 'axios';
import Form from "./common/form"
import Modals from "./common/modals"
import Button from './common/button';
import { success, error } from "../components/common/notification"
import { v4 as uuidv4 } from 'uuid';


const Pokemon = () => {
    // pokemon api(all pokemon)
    const [pokemon, setpokemon] = useState([]);

    // search pokemon based on input
    const [input, setinput] = useState('');

    // modal does not display 
    const [displayModal, setdisplayModal] = useState(false);

    // pokemon list (displays 6 pokemon)
    const [currentPokemon, setcurrentPokemon] = useState([]);

    // filter pokemons
    let filteredPokemon = []
    filteredPokemon = pokemon.filter(pokemon => pokemon.name.includes(input.toLowerCase().trim())).map(data => data.name)
    // Pokemon local storeage list 
    const getPokemonTeam = JSON.parse(localStorage.getItem("pokemon-team"));


    useEffect(() => {
        if (getPokemonTeam == null) {
            setcurrentPokemon([])
        } else {
            setcurrentPokemon(getPokemonTeam);
        }
    }, [])


    // Form Search    
    const handleSearchResults = (input) => {
        setinput(input.notes)
        setdisplayModal(true)
    }

    useEffect(() => {
        axios.get("https://pokeapi.co/api/v2/pokemon?limit=898")
            .then(res => res.data)
            .then(res => setpokemon(res.results))
            .catch(err => console.log(err))
    }, []);

    const hanldePokemonAdd = (e) => {
        const id = uuidv4();
        console.log(currentPokemon.length)
        let newPokemon = { name: e.data, src: e.src, id }
        setcurrentPokemon([...currentPokemon, newPokemon])
        localStorage.setItem("pokemon-team", JSON.stringify([...currentPokemon, newPokemon]));
        success(`Success! Added ${e.data} to team!`)

        if (currentPokemon.length >= 5) {
            error("Error Pokemon team is at 6")
            hanldeClose()
        }

    }
    const hanldeClose = () => {
        setdisplayModal(false)
    }
    const hanldePokemonDelete = (id) => {
        const deletePokemon = currentPokemon.filter((pokemon) => pokemon.id !== id);
        setcurrentPokemon(deletePokemon)
        localStorage.setItem("pokemon-team", JSON.stringify(deletePokemon));
        success('Success! Removed a Pokemon')
    }





    return (

        <>
            <Modals
                modalTitle={
                    `Searched : ${input}`
                }

                modalContent={
                    // if correct pokemon was typed display correct mon
                    // else display full pokemon list
                    <div className='container'>
                        <p className='mx-5'>Results:{<small className='text-center text-kombuGreen font-bold'> {filteredPokemon.length}</small>}</p>

                        {pokemon === null ? <p>Error Please try again</p> :
                            <>

                                {/* {filteredPokemon.push({ results: { name: , idx: pokemon.findIndex((pokemon) => pokemon.name === input.toLowerCase()) + 1 } })} */}

                                {filteredPokemon.length === 0 ?
                                    <>
                                        <p>No Results</p>
                                        <Form handleSubmit={handleSearchResults}
                                            inputStyles={'rounded-lg w-full text-kombuGreen placeholder:text-kombuGreen border-solid border-2 border-light-blue-500 p-3 placeholder:text-ashGray focus:text-kombuGreen'}
                                            inputData={{ text: "text", name: "notes", id: "notes", placeholder: "Search Pokemon", min: 3, max: 15 }}
                                            icon={{ iconName: "FaSearch", iconStyles: "cursor-pointer text-ashGray text-2xl hover:text-gray-500" }}

                                        />

                                        <ul className='grid md:grid-cols-2 gap-4 m-2'>
                                            {pokemon.map((data, idx) =>


                                                <li key={idx} className='container bg-zinc-100 rounded flex flex-col-reverse justify-evenly items-center p-3 w-11/12 mx-auto'>
                                                    <Button event={() => hanldePokemonAdd(data)} name={'Add to team'} styles={'bg-xanadu text-backgroundColor p-2 rounded hover:bg-ashGray'}></Button>
                                                    <img src={`https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${idx + 1}.png`} alt='pokemon'></img>
                                                    <p className='text-kombuGreen font-semibold lg:text-xl capitalize' key={idx}>{data.name}</p>
                                                </li>

                                            )}
                                        </ul>
                                    </>
                                    :
                                    <>
                                        <Form handleSubmit={handleSearchResults}
                                            inputStyles={'rounded-lg w-full text-kombuGreen placeholder:text-kombuGreen border-solid border-2 border-light-blue-500 p-3 placeholder:text-ashGray focus:text-kombuGreen'}
                                            inputData={{ text: "text", name: "notes", id: "notes", placeholder: "Search Pokemon", min: 3, max: 15 }}
                                            icon={{ iconName: "FaSearch", iconStyles: "cursor-pointer text-ashGray text-2xl hover:text-gray-500" }}

                                        />
                                        <ul className='grid md:grid-cols-2 gap-5 m-2'>
                                            {filteredPokemon.map((data, idx) =>
                                                <li key={idx} className='container bg-zinc-100 rounded flex flex-col-reverse justify-evenly items-center p-3 w-9/12 mx-auto' >
                                                    <Button
                                                        event={() => hanldePokemonAdd({ data, src: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${pokemon.findIndex((pokemon) => pokemon.name === data.toLowerCase()) + 1}.png` })}
                                                        name={'Add to team'}
                                                        styles={'bg-xanadu text-backgroundColor p-2 rounded hover:bg-ashGray'}
                                                    ></Button>
                                                    <p className='text-kombuGreen font-semibold lg:text-md capitalize'>#{pokemon.findIndex((pokemon) => pokemon.name === data.toLowerCase()) + 1} {data}</p>
                                                    <img src={`https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${pokemon.findIndex((pokemon) => pokemon.name === data.toLowerCase()) + 1}.png`} alt='pokemon'></img>
                                                </li>
                                            )}
                                        </ul>
                                    </>

                                }

                            </>

                        }
                    </div >
                }
                display={displayModal}
                hanldeModalClose={hanldeClose}
            />

            <Card children={
                <>
                    <h1 className='text-kombuGreen text-center text-xl mb-3'>Create a Pokemon Team</h1>
                    <Form handleSubmit={handleSearchResults}
                        inputStyles={'rounded-lg w-full text-kombuGreen placeholder:text-kombuGreen border-solid border-2 border-light-blue-500 p-3 placeholder:text-ashGray focus:text-kombuGreen'}
                        inputData={{ text: "text", name: "notes", id: "notes", placeholder: "Search Pokemon", min: 3, max: 15 }}
                        icon={{ iconName: "FaSearch", iconStyles: "cursor-pointer text-ashGray text-2xl hover:text-gray-500" }}

                    />
                    <div className='container'>

                        {currentPokemon.length === 0 ?
                            <p className='text-center font-semibold  text-xanadu'>No pokemon in your team! </p>
                            :
                            <>
                                <p className='text-center font-semibold text-xanadu'>Current Pokemon Team:</p>
                                <div className='grid md:grid-cols-2 gap-4 m-2'>
                                    {console.log(currentPokemon.map(data => data))}
                                    {currentPokemon.map((data, idx) =>
                                        <div key={idx} className='container bg-zinc-100 rounded flex flex-col-reverse justify-evenly items-center p-3 w-9/12 mx-auto'>
                                            <Button
                                                event={() => hanldePokemonDelete(data.id)}
                                                name={'Remove From Team'}
                                                styles={'bg-xanadu text-backgroundColor p-2 rounded hover:bg-ashGray'}
                                            ></Button>
                                            <p className='text-kombuGreen font-semibold lg:text-md capitalize'>{data.name}</p>
                                            <img src={data.src} alt='pokemon'></img>

                                        </div>
                                    )}
                                </div>
                            </>

                        }

                    </div>
                </>

            } />

        </>

    );
}

export default Pokemon;